export enum ContactType {
    Father = 1,
    Mother = 2,
    AuntOrUncle = 3,
    Spouse = 4,
    Others = 5
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/ContactType.ts